const MS = ({ width, height, color, ...props }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    <mask
      id="mask0_54_3158"
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="24"
      height="18"
    >
      <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    </mask>
    <g mask="url(#mask0_54_3158)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 3.42999H11.4286V4.57285H24V3.42999ZM24 5.71573H11.4286V6.85859H24V5.71573ZM11.4286 8.0014H24V9.14426H11.4286V8.0014ZM24 10.2871H11.4286V11.43H24V10.2871ZM0 12.5729H24V13.7157H0V12.5729ZM24 14.8585H0V16.0014H24V14.8585ZM0 17.1443H24V18.2871H0V17.1443ZM24 19.43H0V20.5729H24V19.43Z"
        fill="#E1244A"
      />
      <rect y="3.42999" width="13.7143" height="9.14286" fill="#0C3F8E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71425 11.43C6.52432 11.43 7.26877 11.149 7.85549 10.6793C7.5447 10.7952 7.2083 10.8586 6.8571 10.8586C5.27915 10.8586 3.99996 9.57937 3.99996 8.00141C3.99996 6.42345 5.27915 5.14427 6.8571 5.14427C7.20834 5.14427 7.54478 5.20765 7.8556 5.32359C7.26886 4.85379 6.52437 4.57281 5.71425 4.57281C3.8207 4.57281 2.28568 6.10784 2.28568 8.00139C2.28568 9.89493 3.8207 11.43 5.71425 11.43ZM8.15113 10.0607L9.14287 8.93851L10.1346 10.0607L9.87555 8.58566L11.3713 8.50998L10.0565 7.79283L10.9299 6.57624L9.54948 7.15703L9.14287 5.71565L8.73625 7.15703L7.35582 6.57624L8.22922 7.79283L6.91446 8.50998L8.41018 8.58566L8.15113 10.0607Z"
        fill="#FFD34F"
      />
    </g>
  </svg>
);

export default MS;
